export default "__VITE_ASSET__DoxmeQnC__"